<div class="section-title">Device Firmware for {{asset.asset_name}}</div>

@if (devices === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading firmware...
	</div>
}

@if (devices !== undefined && devices.length === 0) {
	<div class="loading-status">
		No firmware data has been gathered for this asset.
	</div>
}

@if (optime) {
	<div>Latest data as of {{optime | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</div>
}

@if (devices !== undefined && devices.length > 0) {
	<table class="log compact">
		<thead>
			<tr>
				<th>ID</th>
				<th>Device</th>
				<th>Type</th>
				<th>Target</th>
				<th>App Version</th>
				<th>Boot Version</th>
			</tr>
		</thead>
		@for (device of devices; track device) {
			<tbody>
				<tr>
					<td>{{device.dev_id}}</td>
					<td>{{device.dev_lbl}}</td>
					<td>{{device.dev_type}}</td>
					<td>{{device.target}}</td>
					<td>{{device.appver}}</td>
					<td>{{device.bootver}}</td>
				</tr>
			</tbody>
		}
	</table>
}